import React from "react";
import {
  Grid,
  TextField,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Divider,
  IconButton,
  Dialog,
} from "@mui/material";
import "react-quill/dist/quill.snow.css";
import CloseIcon from "@mui/icons-material/Close";
import CustomTypography from "../../globalStyles/fonts";
import { disabledFieldSx } from "../../constants/fieldStyles";

const ShippingServiceDetailsModal = ({ shippingService, open, onClose }) => {
  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <DialogTitle>{"Shipping Service Details"}</DialogTitle>
          <IconButton>
            <CloseIcon onClick={onClose} />
          </IconButton>
        </div>
        <Divider style={{ marginBottom: "10px" }} />
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <CustomTypography
                color={"var(--text-heading)"}
                fontSize={14}
                fontWeight={400}
              >
                Service
              </CustomTypography>
              <TextField
                size="small"
                autoFocus
                margin="dense"
                variant="outlined"
                type="text"
                fullWidth
                value={shippingService?.service || ""}
                InputProps={{
                  readOnly: true,
                }}
                sx={disabledFieldSx}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomTypography
                color={"var(--text-heading)"}
                fontSize={14}
                fontWeight={400}
              >
                Country
              </CustomTypography>
              <TextField
                size="small"
                autoFocus
                margin="dense"
                variant="outlined"
                type="text"
                fullWidth
                value={shippingService?.country || ""}
                InputProps={{
                  readOnly: true,
                }}
                sx={disabledFieldSx}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomTypography
                color={"var(--text-heading)"}
                fontSize={14}
                fontWeight={400}
              >
                Entry Point
              </CustomTypography>
              <TextField
                size="small"
                autoFocus
                margin="dense"
                variant="outlined"
                type="text"
                fullWidth
                value={shippingService?.entry_point || ""}
                InputProps={{
                  readOnly: true,
                }}
                sx={disabledFieldSx}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomTypography
                color={"var(--text-heading)"}
                fontSize={14}
                fontWeight={400}
              >
                Exit Point
              </CustomTypography>
              <TextField
                size="small"
                autoFocus
                margin="dense"
                variant="outlined"
                type="text"
                fullWidth
                value={shippingService?.exit_point || ""}
                InputProps={{
                  readOnly: true,
                }}
                sx={disabledFieldSx}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomTypography
                color={"var(--text-heading)"}
                fontSize={14}
                fontWeight={400}
              >
                Min Weight
              </CustomTypography>
              <TextField
                size="small"
                autoFocus
                margin="dense"
                variant="outlined"
                type="text"
                fullWidth
                value={shippingService?.min_weight || ""}
                InputProps={{
                  readOnly: true,
                }}
                sx={disabledFieldSx}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomTypography
                color={"var(--text-heading)"}
                fontSize={14}
                fontWeight={400}
              >
                Max Weight
              </CustomTypography>
              <TextField
                size="small"
                autoFocus
                margin="dense"
                variant="outlined"
                type="text"
                fullWidth
                value={shippingService?.max_weight || ""}
                InputProps={{
                  readOnly: true,
                }}
                sx={disabledFieldSx}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions style={{ padding: 10 }}>
          <Button
            onClick={onClose}
            variant="outlined"
            style={{ textTransform: "none" }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default ShippingServiceDetailsModal;
